














import { computed, defineComponent, nextTick, onMounted, onUnmounted, ref, watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { HideMenuHandlerData } from "@/types";
import { EVENTS } from "@/const";
import BaseFooter from "@/components/BaseFooter";
import BrowserReminderNotification from "@/components/BrowserReminderNotification";
import MainNavigationBar from "@/components/MainNavigationBar";
import WebAppMenu from "@/components/WebAppMenu/WebAppMenu.vue";

export default defineComponent({
  name: "MainNavigationView",
  components: { MainNavigationBar, WebAppMenu, BaseFooter, BrowserReminderNotification },
  setup() {
    const hideMenuManual = ref(false);
    const fullHideMenuManual = ref(false);
    const showNotification = ref(false);
    const { allowAccess } = useAuthUser();
    const isWebApp = ref(false);
    const isMessagePage = ref(false);

    const hideMenuOnMessagePage = (status: HideMenuHandlerData) => {
      if (status.hide !== undefined) {
        isMessagePage.value = status.hide;
      }
    };

    const showWebAppMenu = computed(() => !isMessagePage.value && isWebApp.value);
    const hideMenuHandler = (hideMenuHandlerData: HideMenuHandlerData) => {
      hideMenuManual.value = hideMenuHandlerData?.hide ?? hideMenuManual.value;
      fullHideMenuManual.value = hideMenuHandlerData?.fullHide ?? fullHideMenuManual.value;
    };
    emitter.on<any>(EVENTS.MAIN_MENU_HIDE, hideMenuHandler);
    watch(showNotification, newVal => {
      if (newVal) {
        setTimeout(() => {
          showNotification.value = false;
        }, 10000);
      }
    });

    onMounted(async () => {
      emitter.on<any>(EVENTS.MAIN_MENU_HIDE, hideMenuOnMessagePage);
      if (navigator.standalone || window.matchMedia("(display-mode: standalone)").matches) {
        isWebApp.value = true;
      }
      await nextTick();
      if (navigator.userAgent.includes("Instagram")) {
        setTimeout(() => {
          showNotification.value = true;
        }, 1000);
      }
    });
    onUnmounted(() => {
      emitter.off<any>(EVENTS.MAIN_MENU_HIDE, hideMenuOnMessagePage);
      emitter.off<any>(EVENTS.MAIN_MENU_HIDE, hideMenuHandler);
    });

    return {
      showMenu: allowAccess,
      hideMenuManual,
      showWebAppMenu,
      fullHideMenuManual,
      showNotification,
    };
  },
});
